export default {
  snake: {
    accounts_payable: 'Accounts Payable',
    banks: 'Notes Payable to Banks and Others',
    contingents: 'Contingent Liability',
    other_installments: 'Installment Account (Other)',
    other: 'Other Liabilities',
    unpaid_taxes: 'Unpaid Taxes',
  },
  camel: {
    accountsPayable: 'Accounts Payable',
    banks: 'Notes Payable to Banks and Others',
    contingents: 'Contingent Liability',
    installmentOther: 'Installment Account (Other)',
    other: 'Other Liabilities',
    unpaidTaxes: 'Unpaid Taxes',
  },
  camelToSnake: {
    accountsPayable: 'accounts_payable',
    banks: 'banks',
    installmentOther: 'other_installments',
    other: 'other',
    unpaidTaxes: 'unpaid_taxes',
    contingents: 'contingents',
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/liabilityTypeMap.js